import React, { useEffect, useState } from "react";
import { Client, HistoryClient } from "../../interfaces/client";
import { formatDate } from "../../services/helpers";
import { getClientHistory } from "../../services/clientService";

interface ClientInformationHistoryTableProps {
  client: Client;
}

const ClientInformationHistoryTable: React.FC<
  ClientInformationHistoryTableProps
> = ({ client }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [historyClient, setHistoryClient] = useState<HistoryClient[]>([]);

  useEffect(() => {
    const getHistory = async () => {
      try {
        setLoadingSpinner(true);

        const historyResponse = await getClientHistory(client.clientID);

        setHistoryClient(historyResponse);
      } catch (error) {
        console.error("Error getting client history:", error);
        setErrorMessage("Error getting client history.");
      } finally {
        setLoadingSpinner(false);
      }
    };

    getHistory();
  }, []);

  return (
    <>
      <div className="table-wrapper">
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="table-container" style={{ fontSize: "large" }}>
          <table className="table" style={{ cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "360px" }} title={"Client Name"}>
                  Client Name
                </th>
                <th style={{ width: "180px" }} title={"Denomination"}>
                  Denomination
                </th>
                <th style={{ width: "260px" }} title={"Diocese"}>
                  Diocese
                </th>
                <th style={{ width: "180px" }} title={"Diocese 2"}>
                  Diocese 2
                </th>
                <th style={{ width: "220px" }} title={"Address"}>
                  Address
                </th>
                <th style={{ width: "220px" }} title={"Address 2"}>
                  Address 2
                </th>
                <th style={{ width: "140px" }} title={"City"}>
                  City
                </th>
                <th style={{ width: "120px" }} title={"State"}>
                  State
                </th>
                <th style={{ width: "120px" }} title={"Zip Code"}>
                  Zip Code
                </th>
                <th style={{ width: "140px" }} title={"Country"}>
                  Country
                </th>
                <th style={{ width: "160px" }} title={"Phone Number"}>
                  Phone Number
                </th>
                <th style={{ width: "120px" }} title={"Fax"}>
                  Fax
                </th>
                <th style={{ width: "140px" }} title={"Primary Title"}>
                  Primary Title
                </th>
                <th style={{ width: "160px" }} title={"Primary First Name"}>
                  Primary First Name
                </th>
                <th style={{ width: "160px" }} title={"Primary Last Name"}>
                  Primary Last Name
                </th>
                <th style={{ width: "160px" }} title={"Primary Job Title"}>
                  Primary Job Title
                </th>
                <th style={{ width: "220px" }} title={"Primary Email"}>
                  Primary Email
                </th>
                <th style={{ width: "150px" }} title={"Email Notifications"}>
                  Email Notifications
                </th>
                <th style={{ width: "200px" }} title={"Created Date"}>
                  Created Date
                </th>
                <th style={{ width: "260px" }} title={"Modified By"}>
                  Modified By
                </th>
                <th style={{ width: "200px" }} title={"Modified At"}>
                  Modified At
                </th>
              </tr>
            </thead>
            <tbody>
              {historyClient?.length === 0 ? (
                <tr>
                  <td colSpan={21} style={{ textAlign: "center" }}>
                    No history found.
                  </td>
                </tr>
              ) : (
                historyClient?.map((row, index) => (
                  <tr key={`${row.clientID}-${index}`}>
                    <td className="ellipsis-cell" title={row.clientName ?? ""}>
                      {row.clientName}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.denomination ?? ""}
                    >
                      {row.denomination}
                    </td>
                    <td className="ellipsis-cell" title={row.diocese ?? ""}>
                      {row.diocese}
                    </td>
                    <td className="ellipsis-cell" title={row.diocese2 ?? ""}>
                      {row.diocese2}
                    </td>
                    <td className="ellipsis-cell" title={row.address ?? ""}>
                      {row.address}
                    </td>
                    <td className="ellipsis-cell" title={row.address2 ?? ""}>
                      {row.address2}
                    </td>
                    <td className="ellipsis-cell" title={row.city ?? ""}>
                      {row.city}
                    </td>
                    <td className="ellipsis-cell" title={row.state ?? ""}>
                      {row.state}
                    </td>
                    <td className="ellipsis-cell" title={row.zipCode ?? ""}>
                      {row.zipCode}
                    </td>
                    <td className="ellipsis-cell" title={row.country ?? ""}>
                      {row.country}
                    </td>
                    <td className="ellipsis-cell" title={row.phoneNumber ?? ""}>
                      {row.phoneNumber}
                    </td>
                    <td className="ellipsis-cell" title={row.fax ?? ""}>
                      {row.fax}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.primaryTitle ?? ""}
                    >
                      {row.primaryTitle}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.primaryFirstName ?? ""}
                    >
                      {row.primaryFirstName}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.primaryLastName ?? ""}
                    >
                      {row.primaryLastName}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.primaryJobTitle ?? ""}
                    >
                      {row.primaryJobTitle}
                    </td>
                    <td
                      className="ellipsis-cell"
                      title={row.primaryEmail ?? ""}
                    >
                      {row.primaryEmail}
                    </td>
                    <td>{row.emailNotifications === true ? "yes" : "no"}</td>
                    <td>{formatDate(row.createdDate, "datetime")}</td>
                    <td className="ellipsis-cell" title={row.modifiedBy ?? ""}>
                      {row.modifiedBy}
                    </td>
                    <td>{formatDate(row.modifiedAt, "datetime")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {loadingSpinner && (
          <div className="loading-mask">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default ClientInformationHistoryTable;
